import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { NavController } from '@ionic/angular';
import { NavService } from '../services/nav.service';
import { StoreService } from '../services/store.service';
import { Ui } from '../services/ui.service';
import { CandoGuard } from './cando.guard';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { CommonMessageService } from '../services/common-message.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private can: CandoGuard, private user: UserService, private router: NavController,
    private navService: NavService,
    private ui: Ui,
    private store: StoreService,
    private helper: CommonMessageService
  ) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.log('AUTH ACTIONS::: ');
    this.navService.redirectUrl = next.url[0].path;
    if (this.navService.redirectUrl.match(/403/)) {
      this.navService.redirectUrl = '';
      return false;
    }
    if (this.navService.redirectUrl.match(/login/)) {
      this.navService.redirectUrl = '';
    }
    return this.store.load().then(() => {
      return this.user.me().toPromise().then(r => {
        this.ui.activatedServices = this.ui.services.filter(e => this.ui.hasPermission(e));
        const allService = this.ui.services.flatMap(e => e.childreen?.length === 0 ? e : e.childreen);
        allService.forEach(e => {
          e.show = this.ui.hasPermission(e);
        });
        if (this.user.currentUser.resetToken) {
          this.helper.changePassword();
        }
        console.log('UI.activatedServices', allService);
        return this.can.canActivate(next, state);
      }).catch(err => {
        this.router.navigateRoot('/login');
        return false;
      });
    });
  }
}
